import { render } from "./Participants.vue?vue&type=template&id=34d9552b&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"

import "./Participants.vue?vue&type=style&index=0&id=34d9552b&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d9552b"]])

export default __exports__